import React, { useState, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import { BiSolidUserCircle } from "react-icons/bi";
import { FaAngleDown } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import userimg from "../../images/sidebaruser.png";
import arrowleft from "../../images/Arrow - Left 2.png"
import { pushToDataLayer } from "../utils/dataUserpush";
import { setformmodal, setformstatus, setauthstatus } from "../../redux/formslice";
const Sidebar = ({ isOpen, onClose }) => {
    const dispatch = useDispatch()
    const categorydata = useSelector((state) => state.globalslice.data);
    const [openSubcategory, setOpenSubcategory] = useState(null);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    const [openSubsubcategory, setOpenSubsubcategory] = useState(null);
    const logindata = useSelector(state => state.formslice.logindata);
    const formmodal = useSelector(state => state.globalslice.formmodal);
    const authstatus = useSelector(state => state.formslice.authstatus);
    const [openStatus, setOpenStatus] = useState(1);

    const handleSubcategoryToggle = (category) => {
        setOpenSubcategory(category);
        setOpenSubsubcategory(null);
        setOpenStatus(2);
    };
    useEffect(() => {
        if (!isOpen) {
            setOpenSubcategory(null);
            setOpenSubsubcategory(null);
            setOpenStatus(1);
        }
    }, [isOpen]);

    const handleSubsubcategoryToggle = (subcategory) => {
        setOpenSubsubcategory(subcategory);
        setOpenStatus(3);
    };
    const loginclick = () => {
        dispatch(setformmodal(!formmodal));
        dispatch(setformstatus(1));
    };
    const signupclick = () => {
        dispatch(setformmodal(!formmodal));
        dispatch(setformstatus(2));
    };
    const backcategory = () => {
        if (openStatus === 1) {
            onClose(); // Close the sidebar
        } else if (openStatus === 2) {
            setOpenSubcategory(null);
            setOpenStatus(1);
        } else if (openStatus === 3) {
            setOpenSubsubcategory(null);
            setOpenStatus(2);
        }
    };
    const handlecategoryclick = (categoryName) => {

        pushToDataLayer("clicked_category_from_menu", currentcountry.name, {
            category_name: categoryName,
            page_name: window.location.pathname,
        });
        onClose()
    }
    const handlesubcategoryclick = (categoryName, subCategoryName) => {

        pushToDataLayer("clicked_category_from_menu", currentcountry.name, {
            category_name: categoryName,
            sub_category_name: subCategoryName,
            page_name: window.location.pathname,
        });
        onClose()
    }
   const handlesubcategory2click =(categoryName,subsubCategoryName)=>{
        
        pushToDataLayer("clicked_category_from_menu",currentcountry.name, {
            category_name: categoryName,
            sub_category2_name: subsubCategoryName, 
            page_name: window.location.pathname,
          });
          onClose()
    }

    return (
        <div className={`sidebar ${isOpen ? "open" : ""}`}>
            <div className="sidebar-content">
                <div className="sidebattopsection">
                    <div>
                        <img src={arrowleft} onClick={backcategory}></img>
                    </div>
                    <div onClick={onClose}>
                        <AiOutlineClose size={20} />
                    </div>
                </div>


                <div className="sidebar-top-details">
                    <img src={userimg}></img>
                    {/* <BiSolidUserCircle size={40} /> */}
                    <div className="sidebaruser">
                        <div className="side-welcome">Welcome {logindata.first_name} </div>
                        {
                            !authstatus &&
                            <div className="sidebar-login cursour-pointer" > <span onClick={loginclick}>Login </span> / <span onClick={signupclick}>Signup</span></div>
                        }
                    </div>
                </div>
            </div>

            <div className="sidebarscrool">
                {/* Main Categories */}
                {openStatus === 1 && (
                    <div>
                        <div className="category-headers">Categories</div>
                        {categorydata.map((category) => (
                            <NavLink className="sidebar-category text-decoration-none" key={category.id} to={`/categories/${category.url}`} onClick={() => handlecategoryclick(category.category_name)}>
                                {category.category_name}
                                {category.subcategory?.length > 0 && (
                                    <img src={'/assets/vector_icons/Arrow -right.png'} onClick={(e) => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                        handleSubcategoryToggle(category)
                                    }}  ></img>
                                    // <FaAngleDown size={16} />
                                )}
                            </NavLink>
                        ))}
                    </div>
                )}
                {/* Subcategories */}
                {openStatus === 2 && openSubcategory && (
                    <div>
                        <div className="category-headers" >{openSubcategory.category_name}</div>
                        {openSubcategory.subcategory.map((sub) => (
                            <NavLink to={`/products-category/${sub.url}`} className="sidebar-category text-decoration-none" key={sub.category_id} onClick={()=>handlesubcategoryclick(openSubcategory.category_name,sub.sub_category_name) }>
                                {sub.sub_category_name}
                                {sub.sub_subcategory?.length > 0 && (

                                    <img src={'/assets/vector_icons/Arrow -right.png'} onClick={(e) => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                        handleSubsubcategoryToggle(sub)
                                    }}></img>
                                    // <FaAngleDown size={16}  />
                                )}
                            </NavLink>
                        ))}
                    </div>
                )}

                {/* Sub-subcategories */}
                {openStatus === 3 && openSubsubcategory && (
                    <div>
                        <div className="category-headers" > {openSubsubcategory.sub_category_name}</div>
                        {openSubsubcategory.sub_subcategory.map((sub) => (
                            <NavLink
                                onClick={()=>handlesubcategory2click(openSubcategory.category_name,sub.sub_subcategory_name)}
                                to={`/products-subcategory/${sub.url}`} className="text-decoration-none sidebar-category" key={sub.sub_subcategory_id}>
                                {sub.sub_subcategory_name}
                            </NavLink>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Sidebar;
